module.exports = __webpack_public_path__ + "static/media/WhiteMagicalUs.c53af6e7.jpg";